import { UserDTO } from "../../../../apiclients/bstinsights";
import { INVITATION_NOT_SENT } from "./constants";

export const isUserInvitable = (user: UserDTO) =>
  INVITATION_NOT_SENT === user.accountStatusName &&
  (user?.groups || [])?.length > 0;
